import { createContext } from "react";

export const WizardContext = createContext({
  steps: [] as string[],
  currentStep: 0,
});

export default WizardContext;